import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { ContractorVisitsService } from "@/modules/projects/services/contractorVisits";
import { ApiError } from "@/services/api";
import {
  CancelContractorVisit,
  ReadContractorVisit,
} from "@/types/contractorVisit";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useCancelContractorVisitsMutation = (
  contractorVisitId: string,
) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutationWithErrorHandling<
    ReadContractorVisit,
    ApiError,
    CancelContractorVisit,
    unknown
  >({
    mutationFn: (payload: CancelContractorVisit) =>
      ContractorVisitsService.cancel(contractorVisitId, payload),
    errorTitle: t("projectContractorVisits.errors.cancel"),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.ContractorVisits, contractorVisitId],
      });
      toast({
        title: t("projectContractorVisits.success.cancel"),
      });
    },
  });
};
